import React, { Fragment } from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import InvoiceTableHeader from './InvoiceTableHeader';
import InvoiceTableRow from './InvoiceTableRow';
// import InvoiceTableBlankSpace from './InvoiceTableBlankSpace';
import InvoiceTableFooter from './InvoiceTableFooter';
import cookies from 'utils/cookies';

// const tableRowsCount = 11;
const borderColor = 'lightgrey';
// const borderColor = '#39393900';

const subtotal = (items, dayContractData, monthContractData, billingFields) => {
  let service_logs = [ ...dayContractData, ...monthContractData];
  let total = 0;
  if (items && items.length > 0) {
    items.forEach(item => {
      if( billingFields?.exclude_disc){
        if(billingFields?.transit === 'none' || !billingFields?.transit){
          if (!isNaN(item.totalrate) && (item?.totalrate || item?.totalrate === 0)) {
            total += parseFloat(item.totalrate);
          } else if (item.quantity && item.rate && !isNaN(item.rate)) {
            total += item.quantity * item.rate;
          }
        } else if(billingFields?.transit === 'inbound'){
          if (!isNaN(item.in_totalrate) && (item?.in_totalrate || item?.in_totalrate === 0)) {
            total += parseFloat(item.in_totalrate);
          } else if (item.in_quantity && item.in_rate && !isNaN(item.in_rate)) {
            total += item.in_quantity * item.in_rate;
          }
        } else if(billingFields?.transit === 'outbound'){
          if (!isNaN(item.out_totalrate) && (item?.out_totalrate || item?.out_totalrate === 0)) {
            total += parseFloat(item.out_totalrate);
          } else if (item.out_quantity && item.out_rate && !isNaN(item.out_rate)) {
            total += item.out_quantity * item.out_rate;
          }
        } else if(billingFields?.transit === 'flight' && billingFields?.priority === 'inbound'){
          if (!isNaN(item.in_ftotalrate) && (item?.in_ftotalrate || item?.in_ftotalrate === 0)) {
            total += parseFloat(item.in_ftotalrate);
          } else if (item.in_fquantity && item.in_frate && !isNaN(item.in_frate)) {
            total += item.in_fquantity * item.in_frate;
          }
        } else if(billingFields?.transit === 'flight' && billingFields?.priority === 'outbound'){
          if (!isNaN(item.out_ftotalrate) && (item?.out_ftotalrate || item?.out_ftotalrate === 0)) {
            total += parseFloat(item.out_ftotalrate);
          } else if (item.out_fquantity && item.out_frate && !isNaN(item.out_frate)) {
            total += item.out_fquantity * item.out_frate;
          }
        } else if(billingFields?.transit === 'truck' && billingFields?.priority === 'inbound'){
          if (!isNaN(item.in_ttotalrate) && (item?.in_ttotalrate || item?.in_ttotalrate === 0)) {
            total += parseFloat(item.in_ttotalrate);
          } else if (item.in_tquantity && item.in_trate && !isNaN(item.in_trate)) {
            total += item.in_tquantity * item.in_trate;
          }
        } else if(billingFields?.transit === 'truck' && billingFields?.priority === 'outbound'){
          if (!isNaN(item.out_ttotalrate) && (item?.out_ttotalrate || item?.out_ttotalrate === 0)) {
            total += parseFloat(item.out_ttotalrate);
          } else if (item.out_tquantity && item.out_trate && !isNaN(item.out_trate)) {
            total += item.out_tquantity * item.out_trate;
          }
        }
      } else {
        if(billingFields?.transit === 'none' || !billingFields?.transit){
          if (!isNaN(item.dis_totalrate) && (item?.dis_totalrate || item?.dis_totalrate === 0)) {
            total += parseFloat(item.dis_totalrate);
          } else if (item.dis_quantity && item.dis_rate && !isNaN(item.dis_rate)) {
            total += item.dis_quantity * item.dis_rate;
          }
        } else if(billingFields?.transit === 'inbound'){
          if (!isNaN(item.dis_in_totalrate) && (item?.dis_in_totalrate || item?.dis_in_totalrate === 0)) {
            total += parseFloat(item.dis_in_totalrate);
          } else if (item.dis_in_quantity && item.dis_in_rate && !isNaN(item.dis_in_rate)) {
            total += item.dis_in_quantity * item.dis_in_rate;
          }
        } else if(billingFields?.transit === 'outbound'){
          if (!isNaN(item.dis_out_totalrate) && (item?.dis_out_totalrate || item?.dis_out_totalrate === 0)) {
            total += parseFloat(item.dis_out_totalrate);
          } else if (item.dis_out_quantity && item.dis_out_rate && !isNaN(item.dis_out_rate)) {
            total += item.dis_out_quantity * item.dis_out_rate;
          }
        } else if(billingFields?.transit === 'flight' && billingFields?.priority === 'inbound'){
          if (!isNaN(item.dis_in_fquantity) && (item?.dis_in_fquantity || item?.dis_in_fquantity === 0)) {
            total += parseFloat(item.dis_in_fquantity);
          } else if (item.dis_in_fquantity && item.dis_in_frate && !isNaN(item.dis_in_frate)) {
            total += item.dis_in_fquantity * item.dis_in_frate;
          }
        } else if(billingFields?.transit === 'flight' && billingFields?.priority === 'outbound'){
          if (!isNaN(item.dis_out_fquantity) && (item?.dis_out_fquantity || item?.dis_out_fquantity === 0)) {
            total += parseFloat(item.dis_out_fquantity);
          } else if (item.dis_out_fquantity && item.dis_out_frate && !isNaN(item.dis_out_frate)) {
            total += item.dis_out_fquantity * item.dis_out_frate;
          }
        } else if(billingFields?.transit === 'truck' && billingFields?.priority === 'inbound'){
          if (!isNaN(item.dis_in_tquantity) && (item?.dis_in_tquantity || item?.dis_in_tquantity === 0)) {
            total += parseFloat(item.dis_in_tquantity);
          } else if (item.dis_in_tquantity && item.dis_in_trate && !isNaN(item.dis_in_trate)) {
            total += item.dis_in_tquantity * item.dis_in_trate;
          }
        } else if(billingFields?.transit === 'truck' && billingFields?.priority === 'outbound'){
          if (!isNaN(item.dis_out_tquantity) && (item?.dis_out_tquantity || item?.dis_out_tquantity === 0)) {
            total += parseFloat(item.dis_out_tquantity);
          } else if (item.dis_out_tquantity && item.dis_out_trate && !isNaN(item.dis_out_trate)) {
            total += item.dis_out_tquantity * item.dis_out_trate;
          }
        }
      }
    });
  }
  if (service_logs && service_logs.length > 0) {
    service_logs.forEach(item => {
      if (!isNaN(item.totalrate) && (item?.totalrate || item?.totalrate === 0)) {
        total += parseFloat(item.totalrate);
      } else if (item.quantity && item.rate && !isNaN(item.rate)) {
        total += item.quantity * item.rate;
      }
    });
  }
  return total;
};

const grandtotal = (items, dayContractData, monthContractData, tax_details, billingFields, oneOff) => {
  let total = subtotal(items, dayContractData, monthContractData, billingFields) || 0;
  let grandtotal = total;
  if(tax_details && tax_details.length > 0){
    tax_details.forEach(tax => {
      let taxval = 0;
      if(tax.type === 'Percentage'){
        taxval = (total * tax.value) / 100;
      } else {
        taxval = tax.value;
      }
      grandtotal = grandtotal + taxval;
    });
  }
  if(oneOff && oneOff.length > 0){
    oneOff.forEach(oOf => {
      grandtotal = oOf.operation === 'SUB' ? parseFloat(grandtotal) - parseFloat(oOf.amount) : parseFloat(grandtotal) + parseFloat(oOf.amount);
    });
  }
  return grandtotal ;
};

const styles = StyleSheet.create({
  tableWrapper: { marginTop: 0, },
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    // marginTop: 24,
    borderWidth: 1,
    borderColor: 'lightgrey',
    // borderColor: borderColor,
  },
  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: 0,
    paddingTop: 20
    // borderBottom: '1px solid lightgrey',
  },
  flightTitle: { fontSize: 14, },
  totalBorder: {
    borderBottomColor: borderColor,
    borderBottomWidth: 1,
    borderTopColor: borderColor,
    borderTopWidth: 1,
  },
  subTotalRow: {
    flexDirection: 'row', 
    alignItems: 'center',      
  },
  offSetCol: { width: '60%', },
  description: {
    width: '20%',
    textAlign: 'right',
    borderLeftColor: borderColor,
    borderLeftWidth: 1,
    paddingRight: 8,
    padding: 4,
    height: '100%',
    fontSize: 10,
  },
  total: {
    width: '20%',
    fontSize: 10,
    fontWeight: 600,
    padding: 4, 
    paddingRight: 8,
    paddingLeft: 12,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  subTotalContainer: { marginTop: 20, },
  mt2: {
    marginTop: 30,
    borderBottom: '1px solid lightgrey', 
  },
  invoiceNote: {
    fontSize: 8,
    textAlign: 'left',
    color: 'grey',
    marginTop: 'auto',
    padding: 4,
  },
});

const getQuantity = (item, billingFields) => {
  let quantity = 0;
  if(billingFields?.exclude_disc) {
    if(billingFields?.transit === 'none' || !billingFields?.transit){
      quantity = item.quantity;
    } else if(billingFields?.transit === 'inbound'){
      quantity = item.in_quantity;
    } else if(billingFields?.transit === 'outbound'){
      quantity = item.out_quantity;
    } else if(billingFields?.transit === 'flight' && billingFields?.priority === 'inbound'){
      quantity = item.in_fquantity;
    } else if(billingFields?.transit === 'flight' && billingFields?.priority === 'outbound'){
      quantity = item.out_fquantity;
    } else if(billingFields?.transit === 'truck' && billingFields?.priority === 'inbound'){
      quantity = item.in_tquantity;
    } else if(billingFields?.transit === 'truck' && billingFields?.priority === 'outbound'){
      quantity = item.out_tquantity;
    }
  } else {
    if(billingFields?.transit === 'none' || !billingFields?.transit){
      quantity = item.dis_quantity;
    } else if(billingFields?.transit === 'inbound'){
      quantity = item.dis_in_quantity;
    } else if(billingFields?.transit === 'outbound'){
      quantity = item.dis_out_quantity;
    } else if(billingFields?.transit === 'flight' && billingFields?.priority === 'inbound'){
      quantity = item.dis_in_fquantity;
    } else if(billingFields?.transit === 'flight' && billingFields?.priority === 'outbound'){
      quantity = item.dis_out_fquantity;
    } else if(billingFields?.transit === 'truck' && billingFields?.priority === 'inbound'){
      quantity = item.dis_in_tquantity;
    } else if(billingFields?.transit === 'truck' && billingFields?.priority === 'outbound'){
      quantity = item.dis_out_tquantity;
    }
  }
  return quantity;
};

const InvoiceItemsTable = ({ invoice }) => (
  <Fragment>
    <View style={styles.tableWrapper} wrap={true}>
      {
        invoice?.flightdata && invoice?.flightdata.length > 0 ?
          invoice.flightdata.map((flight, index) => {
            // Sort contractData by position for flight-level display
            const sortedContractData = flight?.contractData ? [...flight.contractData].sort((a, b) => (a.position || 0) - (b.position || 0)) : [];
            const filteredContractData = sortedContractData.filter(item => (parseFloat(getQuantity(item, invoice.billingFields)) !== parseFloat(0) && getQuantity(item, invoice.billingFields)));
            return (
              <View key={index} wrap={true}>
                <View style={styles.titleContainer}>
                  <Text style={styles.flightTitle}>{flight?.label/*+'('+flight?.org+'-'+flight?.dest+')'*/ || null}</Text>
                </View>
                <View style={styles.tableContainer}>
                  <InvoiceTableHeader borderColor={borderColor} />
                  <InvoiceTableRow localeObj={invoice.localeObj} type={'flights'} items={filteredContractData} borderColor={borderColor} searchFields={invoice.searchFields} billingFields={invoice.billingFields} />
                  {/* <InvoiceTableBlankSpace rowsCount={ tableRowsCount - invoice.items.length} borderColor={borderColor} /> */}
                  <InvoiceTableFooter localeObj={invoice.localeObj} items={filteredContractData} borderColor={borderColor} billingFields={invoice.billingFields} />
                </View>
              </View>
            );
          }) : null
      }
      {/* <View break> */}
      {
        invoice.daylogdata && invoice.daylogdata.length > 0 ?
          invoice.daylogdata.map((daylog, index) => {
            // Sort contractData by position for daylog-level display
            const sortedContractData = daylog?.contractData ? [...daylog.contractData].sort((a, b) => (a.position || 0) - (b.position || 0)) : [];
            let contractData = sortedContractData.filter(item => parseFloat(item.quantity) !== parseFloat(0) && item.quantity) || [];
            return (
              <>
                <View key={index} wrap={true}>
                  <View style={styles.titleContainer}>
                    <Text style={styles.flightTitle}>{daylog?.label || null}</Text>
                  </View>
                  <View style={styles.tableContainer}>
                    <InvoiceTableHeader borderColor={borderColor} />
                    <InvoiceTableRow localeObj={invoice.localeObj} type={'daylogs'} items={contractData} borderColor={borderColor} searchFields={invoice.searchFields} billingFields={{ exclude_disc : true }} />
                    <InvoiceTableFooter localeObj={invoice.localeObj} items={contractData} borderColor={borderColor} billingFields={{ exclude_disc : true }} />
                  </View>
                </View>
              </>
            );
          })
          : null
      }
      {
        invoice.monthlogdata && invoice.monthlogdata.length > 0 ?
          invoice.monthlogdata.map((monthlog, index) => {
            // Sort contractData by position for monthlog-level display
            const sortedContractData = monthlog?.contractData ? [...monthlog.contractData].sort((a, b) => (a.position || 0) - (b.position || 0)) : [];
            let contractData = sortedContractData.filter(item => parseFloat(item.quantity) !== parseFloat(0) && item.quantity) || [] ;
            if(contractData)
              return (
                <>
                  <View key={index} wrap={true}>
                    <View  style={styles.titleContainer}>
                      <Text style={styles.flightTitle}>{monthlog.label}</Text>
                    </View>
                    <View style={styles.tableContainer}>
                      <InvoiceTableHeader borderColor={borderColor} />
                      <InvoiceTableRow localeObj={invoice.localeObj} type={'monthlogs'} items={contractData} borderColor={borderColor} searchFields={invoice.searchFields} billingFields={{ exclude_disc : true }} />
                      <InvoiceTableFooter localeObj={invoice.localeObj} items={contractData} borderColor={borderColor} billingFields={{ exclude_disc : true }} />
                    </View>
                  </View>
                </>
              );
          })
          : null
      }
      {
        <>
          <View wrap={true}>
            {invoice?.flightdata && invoice?.flightdata.length > 0 ? <Text style={[styles.flightTitle, styles.mt2]}>Summary of all Flights</Text> : null}
            <View style={styles.titleContainer}>
              <Text style={styles.flightTitle}>{invoice.airlines_code}</Text>
              {/* <Text style={styles.flightTitle}>$ 58</Text> */}
            </View>
            {/* Sort invoiceData by position for summary display */}
            {(() => {
              const sortedInvoiceData = invoice?.invoiceData ? [...invoice.invoiceData].sort((a, b) => (a.position || 0) - (b.position || 0)) : [];
              const filteredInvoiceData = sortedInvoiceData.filter(item => parseFloat(getQuantity(item, invoice.billingFields)) !== parseFloat(0) && getQuantity(item, invoice.billingFields)) || [];
              return (
                <View style={styles.tableContainer}>
                  <InvoiceTableHeader borderColor={borderColor} />
                  <InvoiceTableRow localeObj={invoice.localeObj} type={'flights'} items={filteredInvoiceData} borderColor={borderColor} searchFields={invoice.searchFields} billingFields={invoice.billingFields} />
                  {/* <InvoiceTableBlankSpace rowsCount={ tableRowsCount - invoice.invoiceData.length} borderColor={borderColor} /> */}
                  <InvoiceTableFooter localeObj={invoice.localeObj} items={filteredInvoiceData} borderColor={borderColor} billingFields={invoice.billingFields} />
                  {/* <Text style={styles.invoiceNote}>*** Minimum rate of $99 will be applicable.</Text> */}
                </View>
              );
            })()}
          </View>
          <View wrap={false}>
            <View style={styles.titleContainer}>
              <Text style={styles.flightTitle}>Day Logs</Text>
              {/* <Text style={styles.flightTitle}>$ 58</Text> */}
            </View>
            {/* Sort dayContractData by position */}
            {(() => {
              const sortedDayContractData = invoice?.dayContractData ? [...invoice.dayContractData].sort((a, b) => (a.position || 0) - (b.position || 0)) : [];
              return (
                <View style={styles.tableContainer}>
                  <InvoiceTableHeader borderColor={borderColor} />
                  <InvoiceTableRow localeObj={invoice.localeObj} type={'daylogs'} items={sortedDayContractData} borderColor={borderColor} searchFields={invoice.searchFields} billingFields={{ exclude_disc : true }} />
                  {/* <InvoiceTableBlankSpace rowsCount={ tableRowsCount - invoice.items.length} borderColor={borderColor} /> */}
                  <InvoiceTableFooter localeObj={invoice.localeObj} items={sortedDayContractData} borderColor={borderColor} billingFields={{ exclude_disc : true }} />
                </View>
              );
            })()}
          </View>
          <View wrap={false}>
            <View style={styles.titleContainer}>
              <Text style={styles.flightTitle}>Month Logs</Text>
              {/* <Text style={styles.flightTitle}>$ 58</Text> */}
            </View>
            {/* Sort monthContractData by position */}
            {(() => {
              const sortedMonthContractData = invoice?.monthContractData ? [...invoice.monthContractData].sort((a, b) => (a.position || 0) - (b.position || 0)) : [];
              return (
                <View style={styles.tableContainer}>
                  <InvoiceTableHeader borderColor={borderColor} />
                  <InvoiceTableRow localeObj={invoice.localeObj} type={'monthlogs'} items={sortedMonthContractData} borderColor={borderColor} searchFields={invoice.searchFields} billingFields={{ exclude_disc : true }} />
                  {/* <InvoiceTableBlankSpace rowsCount={ tableRowsCount - invoice.items.length} borderColor={borderColor} /> */}
                  <InvoiceTableFooter localeObj={invoice.localeObj} items={sortedMonthContractData} borderColor={borderColor} billingFields={{ exclude_disc : true }} />
                </View>
              );
            })()}
          </View>
        </>
      }
      {/* </View> */}
    </View>

    <View style={styles.subTotalContainer} wrap={false}>
      <View style={styles.subTotalRow}>
        <Text style={styles.offSetCol}></Text>
        <Text style={[styles.description, styles.totalBorder]}>Sub Total</Text>
        <View style={[styles.total, styles.totalBorder]}>
          <Text>{ cookies.get('currency') }</Text> 
          <Text>{subtotal( invoice?.invoiceData  || [], invoice?.dayContractData || [], invoice?.monthContractData || [], invoice.billingFields ).toLocaleString(invoice.localeObj.locale, invoice.localeObj.options)}</Text>
        </View>
      </View>
      <>
        {
          invoice.invoice_info.tax && invoice.invoice_info.tax.length > 0 ?
            invoice.invoice_info.tax.map((tax, index) => {
              let taxval = 0;
              if(tax.type === 'Percentage'){
                taxval = (subtotal(invoice?.invoiceData  || [], invoice?.dayContractData || [], invoice?.monthContractData || [], invoice.billingFields) * tax.value) / 100;
              } else {
                taxval = tax.value;
              }
              return (
                <View style={styles.subTotalRow} key={index}>
                  <Text style={styles.offSetCol}></Text>
                  <Text style={styles.description} >{tax.title} {tax.type === 'Percentage' ? tax.value + '%' : null}</Text>
                  <View style={styles.total}>
                    <Text>{ cookies.get('currency') }</Text> 
                    <Text>{taxval.toLocaleString(invoice.localeObj.locale, invoice.localeObj.options)}</Text>
                  </View>
                </View>
              );
            }) : null
        } &&
        {
          invoice.oneOff && invoice.oneOff.length > 0 ?
            invoice.oneOff.flatMap((oOf, index) => {
              const repeatCount = oOf?.cycle.includes('C1,C2') && invoice.searchFields.period === 'month' ? 2 : 1;
              return Array.from({ length: repeatCount }).map((_, repeatIndex) => (
                <View style={styles.subTotalRow} key={`${index}-${repeatIndex}`}>
                  <Text style={styles.offSetCol}></Text>
                  <Text style={styles.description}>{oOf.label}</Text>
                  <View style={styles.total}>
                    <Text>{cookies.get('currency')}</Text>
                    <Text>{oOf.operation === 'SUB' ? '-' : ''}{oOf.amount}</Text>
                  </View>
                </View>
              ));
            }) : null
        }
      </>
      <View style={[styles.subTotalRow, styles.row]}>
        <Text style={styles.offSetCol}></Text>
        <Text style={[styles.description, styles.totalBorder]}>GRAND TOTAL</Text>
        <View style={[styles.total, styles.totalBorder]}>
          <Text>{ cookies.get('currency') }</Text> 
          <Text>{grandtotal( invoice?.invoiceData  || [], invoice?.dayContractData || [], invoice?.monthContractData || [], invoice.invoice_info.tax, invoice.billingFields, invoice.oneOff ).toLocaleString(invoice.localeObj.locale, invoice.localeObj.options) }</Text>
        </View>
      </View>
    </View>
  </Fragment>
);

export default InvoiceItemsTable;